import { toMillis } from '~/lib/timestamps';
import type { TimeEntry } from '~/types/models';

export function elapsedTimeSeconds(entry: Pick<TimeEntry, 'startedAt' | 'activeStartedAt' | 'endedAt' | 'durationSeconds' | 'status'>, now = Date.now()): number {
    if (entry.status !== 'running') return Math.max(0, Math.round(Number(entry.durationSeconds || 0)));
    const startedAt = toMillis(entry.activeStartedAt || entry.startedAt);
    if (!startedAt) return 0;
    return Math.max(0, Math.round(Number(entry.durationSeconds || 0)) + Math.floor((now - startedAt) / 1000));
}

export function formatTrackedDuration(seconds: number, options: { compact?: boolean } = {}): string {
    const safeSeconds = Math.max(0, Math.floor(Number(seconds || 0)));
    const hours = Math.floor(safeSeconds / 3600);
    const minutes = Math.floor((safeSeconds % 3600) / 60);
    const remainingSeconds = safeSeconds % 60;

    if (options.compact) {
        if (hours > 0) return `${hours}h ${minutes}m`;
        if (minutes > 0) return `${minutes}m`;
        return `${remainingSeconds}s`;
    }

    return [hours, minutes, remainingSeconds]
        .map(value => String(value).padStart(2, '0'))
        .join(':');
}

export function resolveManualDurationSeconds(startedAt: Date, endedAt: Date): number {
    const duration = Math.floor((endedAt.getTime() - startedAt.getTime()) / 1000);
    if (!Number.isFinite(duration) || duration <= 0) {
        throw new Error('The end time must be after the start time.');
    }
    return duration;
}

export function sumTrackedSeconds(entries: Array<Pick<TimeEntry, 'durationSeconds' | 'status' | 'startedAt' | 'activeStartedAt' | 'endedAt'>>, now = Date.now()): number {
    return entries.reduce((total, entry) => total + elapsedTimeSeconds(entry, now), 0);
}
